import DetailsEdit from '../../components/DetailsEdit';
import { CardMode } from 'txp-data/lib/schema/viewSchema/CardMode';
import TxpStyle from 'txp-data/lib/schema/viewSchema/TxpStyle';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';
import PostalAddress from 'txp-data/lib/schema/innerSchema/PostalAddress';

/**
 * returns the Details Edit control
 */
export default function getDetailsEditControl(
    cardMode: CardMode,
    txpStyle: TxpStyle,
    readOnlyLines: TxpDataRow[],
    editableText: string,
    editableData: TxpDataRow,
    location: PostalAddress,
    onLocationChanged?: (location: PostalAddress, stringAddress: string) => void,
    getDisplayAddress?: (location: PostalAddress) => string
): JSX.Element {
    return DetailsEdit({
        cardMode: cardMode,
        txpStyle: txpStyle,
        readOnlyLines: readOnlyLines,
        editableText: editableText,
        editableData: editableData,
        location: location,
        onLocationChanged: onLocationChanged,
        getDisplayAddress: getDisplayAddress,
    });
}
